import { useRef } from "react";
import Text from "../../../Components/Text/Text";
import { useWindowScroll } from "../../../hooks/useWindowScroll";
import ContactForm from "../../../Components/ContactForm/ContactForm";

export default function ContactSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section ref={ref}>
      <div className="py-24 px-4 mx-auto container overflow-hidden">
        <div
          className={`transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >
          <Text type="h2" size="lg" className="font-semibold md:w-[700px]">
            Learn how we deliver mobile apps on time, on budget.
          </Text>
          <Text className="block my-8">
            Mitigate risk and find market fit with early validation with Agile
            Labs.
          </Text>
        </div>
        <ContactForm
          className={`transition-all duration-700 mt-12 ${
            show ? "" : "opacity-0 translate-y-96"
          }`}
        />
      </div>
    </section>
  );
}
